app.service('productTabDescription',function(console, modal, log) {
	var $self, $expandTableDetails, $basicDetails, $fullDetails;

	function setEvents(){
		$expandTableDetails.click(toggleTable);
	}
	function setElements(){
		$self=$('#description');
		$expandTableDetails=$('#toogle-tech-details', $self);
		$basicDetails=$('.js-full-tech-details', $self);
		$fullDetails=$('.js-basic-tech-details', $self);
	}
	function toggleTable() {
		$self.toggleClass('full-tech');
		if ($self.hasClass('full-tech')) {
			$.scrollTo($basicDetails);
		} else {
			$.scrollTo($fullDetails);
		}
	}
	function init(){
		setElements();
		setEvents();
	}
	return {
		init:init
	};
});
